var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page-layout',{staticClass:"arvore-produtos",attrs:{"title":"Árvore de produtos"}},[_c('arvore-produtos-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }